const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20tones%2C%20abstract%20geometric%20style%2C%20coral%20and%20amber%20color%20palette%2C%20clean%20background%2C%20editorial%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '创造营这季的三公真的是全程高能啊，黑马选手那段舞蹈我反复看了五遍，太炸了！终于有一个不靠流量靠实力的选手站出来了。',
    likes: '2.4万',
    tag: '创造营',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20tones%2C%20abstract%20geometric%20style%2C%20amber%20and%20coral%20color%20palette%2C%20clean%20background%2C%20editorial%20design%20with%20different%20geometric%20pattern&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '电竞老司机',
    time: '3小时前',
    content: '那支黑马战队确实有点东西，战术体系明显是经过精心设计的，不是靠运气。看好他们进四强，这届世界杯中国区有看头了。',
    likes: '1.8万',
    tag: '电竞',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20tones%2C%20abstract%20geometric%20style%2C%20coral%20color%20palette%2C%20clean%20background%2C%20editorial%20design%20with%20circular%20pattern&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '乐评人小K',
    time: '4小时前',
    content: '歌手这季赛制改动虽然仓促，但效果意外的好。复活赛的设计给了一些遗珠选手第二次机会，这个改动值得保留到下一季。',
    likes: '9.6千',
    tag: '音乐',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20portrait%20in%20warm%20tones%2C%20abstract%20geometric%20style%2C%20amber%20color%20palette%2C%20clean%20background%2C%20editorial%20design%20with%20triangular%20pattern&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '街舞爱好者',
    time: '6小时前',
    content: '评分争议这事儿我站选手这边，裁判的标准确实不够透明。建议以后公开每位裁判的打分明细，这样才能服众。',
    likes: '7.3千',
    tag: '街舞',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            网友热议
          </h2>
          <p className="text-sm text-foreground-500 mt-2">大赛吃瓜精彩评论精选，看看吃瓜群众都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.name}</span>
                    <span className="px-1.5 py-0.5 rounded bg-primary-100 text-primary-600 text-[10px] font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.content}</p>
              <div className="flex items-center gap-4">
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  <i className="ri-thumb-up-line"></i>
                  {item.likes}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}